import React from 'react';
import ReactDOM from 'react-dom';
import { isIos } from '@/consts';
import { isInDebankApp, isPageVisible } from '@/utils/common';

import { AndroidDownloadModal } from './AndroidDownloadModal';

// 绕过ios上浏览器设置阻止弹窗
export const openLink = (link: string) => {
  const alink = document.createElement('a');
  alink.href = link;
  alink.click();
};

export const openInDebank = (
  params: {
    showDownloadGuide?: boolean;
    wait?: number;
    link?: string;
  } = {},
) => {
  const inDebankApp = isInDebankApp();
  const { showDownloadGuide = true, wait = 2000, link = 'assets' } = params;
  const location = window.location;
  // const urlAddress = location.pathname.match(/(profile|hi)\/([^/]+)/)?.[2];
  // const isHiChatPage = location?.pathname?.startsWith('/hi');
  // const { pathname } = location;
  // let interlink = 'assets';
  // if (isOpenHi || isHiChatPage) {
  //   interlink = `hi/${urlAddress}`;
  // } else if (pathname?.includes('profile') && urlAddress) {
  //   interlink = `profile/${urlAddress}`;
  // }
  // const targetLink = link || interlink;
  const linkPrefix = 'debank://';
  location.href = `${linkPrefix}${link}`;
  if (!showDownloadGuide || inDebankApp) return;

  const timer = setTimeout(() => {
    if (isPageVisible()) {
      if (isIos) {
        openLink('https://apps.apple.com/us/app/debank-crypto-defi-portfolio/id1621278377');
      } else {
        let downloadModalEle = document.querySelector('#downloadModal');

        if (!downloadModalEle) {
          downloadModalEle = document.createElement('div');
          downloadModalEle.setAttribute('id', 'downloadModal');
          document.body.appendChild(downloadModalEle);
        }

        ReactDOM.render(<AndroidDownloadModal key={+new Date()} />, downloadModalEle);
      }
    }
    clearTimeout(timer);
  }, wait);
};
